export default __webpack_public_path__ + "static/media/jupeb.62902cd1.png";